/* eslint-disable no-restricted-globals */
import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from '../serviceWorker';
import CountdownCalendarEmbed from '../embeds/CountdownCalendarEmbed';
import '../../node_modules/font-awesome/css/font-awesome.min.css';

window.onload = function() {
  // The load event is fired when the whole page has loaded.
  const collection = document.getElementsByClassName('countdown-calendar-root');
  for (let i = 0; i < collection.length; i++) {
    let countdownCalendarRootId = collection[i].id;
    const countdownCalendarRoot = document.getElementById(countdownCalendarRootId);
    const attrPathAlias = countdownCalendarRoot ? countdownCalendarRoot.getAttribute('attr-path-alias') : null;
    ReactDOM.render(<CountdownCalendarEmbed pathAlias={attrPathAlias} />, countdownCalendarRoot);
  }
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
